import { z } from 'zod';

/**
 * Sign Up Form Schema
 *
 * Defines the validation schema, type definition, and default values for the user sign-up form.
 * This module ensures that all required fields (email, first name, last name, country, and terms acceptance)
 * are properly validated before submission.
 *
 * Exports:
 * - getSignupFormValidationSchema: Zod validation schema for the sign-up form
 * - signupFormType: TypeScript type for the sign-up form, inferred from the schema
 * - signupFormDefaultValue: Default initial values for the sign-up form
 *
 * @module signupForm
 */

export const getSignupFormValidationSchema = z.object({
  email: z.string().min(1, "user name can't be empty"),
  firstName: z.string().min(1, "First name can't be empty"),
  lastName: z.string().min(1, "Last name can't be empty"),
  country: z.string().min(1, "Country is required"),
  terms: z.boolean().refine((val) => val, {
    message: "You must accept the terms and conditions",
  }),
});

export type signupFormType = z.infer<typeof getSignupFormValidationSchema>;

export const signupFormDefaultValue: signupFormType = {
  email: '',
  firstName: '',
  lastName: '',
  country: '',
  terms: false
};
